// React
import { useCallback, useEffect, useState } from "react";

// Store
import useProfileStore from "../../../store/profileStore.js";
import useSiteStore from "../../../store/siteStore.js";

// Components
import { useMediaQuery } from '@mui/material';
import LoadingProgress from "../../../components/custom/LoadingProgress.js";

// Pages
import ParentHome from "./parentHome.js";
import ParentHomeMobile from "./parentHomeMobile.js";

// Other
import { formatCalendarWeekString } from "../../../utils/index.js";
import { getWeeklyScheduleOfAthlete } from '../../../service/httpService/weeklySchedule/index.js';
import { getAthletesOfParent } from '../../../service/httpService/athlete/index.js';
import { getAllFeedbacksOfWeekOfAthlete } from '../../../service/httpService/feedback/index.js';
import { getCoachesOfAthlete } from '../../../service/httpService/coach/index.js';

const DashboardParent = () => {
	const { userEmail } = useProfileStore();
	const { allOpen, isLoading, mobile, selectedCalenderWeek, selectedTab, setAllOpen, setCalendarWeekString, setFeedbacks, setLoading, setTableRowsOpen, setWeeklySchedule,
		setWeeklyScheduleLoading, tableRowsOpen, weeklySchedule, year } = useSiteStore();
	const isTablet = useMediaQuery('(min-width:601px) and (max-width:1000px)');

	// Use mobile-like layout for both mobile and tablet
	const compactLayout = mobile || isTablet;

	const [coaches, setCoaches] = useState();
	const [isCoachesLoading, setCoachesLoading] = useState(false);
	const [athletes, setAthletes] = useState([]);
	const [selectedAthlete, setSelectedAthlete] = useState(JSON.parse(localStorage.getItem('selectedAthlete')));
	const [selectOpen, setSelectOpen] = useState(false);

	const onChangeSelectedAthlete = (event) => {
        setSelectedAthlete(event.target.value);
    }

	const handleSelectOpen = () => {
		if (athletes.length > 0) {
			setSelectOpen(true);
		}
	}

	const handleSelectClose = () => {
		setSelectOpen(false);
	}

    const openAndCloseAll = () => {
        let values = [...tableRowsOpen];
        for (let i = 0; i < values.length; i++) {
            values[i] = !allOpen;
        }
        setTableRowsOpen(values);
        setAllOpen(!allOpen);
    }

    const openAndCloseTableRow = (index) => {
        let values = [...tableRowsOpen];
        values[index] = !values[index];
        setTableRowsOpen(values);
    }

	const getWeeklySchedule = useCallback((email) => {
        setFeedbacks([]);
        setWeeklySchedule(undefined);
        setWeeklyScheduleLoading(true);

        getWeeklyScheduleOfAthlete(email, year, selectedCalenderWeek)
            .then(response => {
                let weeklyScheduleFeedbacks = response.data;
                setWeeklySchedule(weeklyScheduleFeedbacks);
                setWeeklyScheduleLoading(false);
                getAllFeedbacksOfWeekOfAthlete(email, year, selectedCalenderWeek)
                    .then(response => {
                        let feedbacksResponse = response.data;
                        setFeedbacks(feedbacksResponse);
                    })
                    .catch(() => {
                        setWeeklyScheduleLoading(false);
                    });
            })
            .catch(() => {
                setWeeklyScheduleLoading(false);
            });
    }, [selectedCalenderWeek, setFeedbacks, setWeeklySchedule, setWeeklyScheduleLoading, year]);

    useEffect(() => {
    	localStorage.setItem('selectedCalenderWeek', JSON.stringify(selectedCalenderWeek));
    }, [selectedCalenderWeek]);

    useEffect(() => {
        localStorage.setItem('selectedAthlete', JSON.stringify(selectedAthlete));
    }, [selectedAthlete]);

    useEffect(() => {
        localStorage.setItem('selectedTab', JSON.stringify(selectedTab));
    }, [selectedTab]);

    useEffect(() => {
        getAthletesOfParent(userEmail)
            .then(response => {
                setAthletes(response.data);
                setLoading(false);

                if (response.data.length > 0) {
                    const savedAthlete = JSON.parse(localStorage.getItem('selectedAthlete'));
                    if (savedAthlete) {
                        // Find the matching athlete from the response data by email
                        const matchingAthlete = response.data.find(a => a.profile.email === savedAthlete.profile.email);
                        setSelectedAthlete(matchingAthlete || response.data[0]);
                    } else {
                        setSelectedAthlete(response.data[0]);
                    }
                } else {
                    setSelectedAthlete(null);
                }
            })
            .catch(() => {});
    }, [userEmail, setLoading]);

    useEffect(() => {
        if (!selectedAthlete) 
			return;

        setCoachesLoading(true);
        getCoachesOfAthlete(selectedAthlete.profile.email)
            .then(response => {
                setCoaches(response.data);
                setCoachesLoading(false);
            })
            .catch(() => {
                setCoachesLoading(false);
            });
        getWeeklySchedule(selectedAthlete.profile.email);
        setCalendarWeekString(formatCalendarWeekString(selectedCalenderWeek, year));
    }, [getWeeklySchedule, selectedCalenderWeek, selectedAthlete, year, setCalendarWeekString]);

	useEffect(() => {
        let values = [];
        if (weeklySchedule !== undefined && weeklySchedule.trainingSessions !== undefined) {
            for (let i = 0; i < weeklySchedule.trainingSessions.length; i++) {
                values.push(allOpen); 
            }
            setTableRowsOpen(values);
        }
    }, [weeklySchedule, allOpen, setTableRowsOpen]);

    if (compactLayout) {
        return (
            <>
                <ParentHomeMobile
                    onChangeSelectedAthlete={ onChangeSelectedAthlete }
                    coaches={ coaches }
                    openAndCloseAll={ openAndCloseAll }
                    openAndCloseTableRow={ openAndCloseTableRow }
                    selectedAthlete={ selectedAthlete }
                    athletes={ athletes }
                    selectOpen={ selectOpen }
                    handleSelectOpen={ handleSelectOpen }
                    handleSelectClose={ handleSelectClose } />
					
                {(isLoading === true || isCoachesLoading === true) && (
                    <LoadingProgress/>
                )}
            </>

        );
    }

    return (
        <ParentHome
            onChangeSelectedAthlete={ onChangeSelectedAthlete }
            coaches={ coaches }
            openAndCloseAll={ openAndCloseAll }
            openAndCloseTableRow={ openAndCloseTableRow }
            selectedAthlete={ selectedAthlete }
            athletes={ athletes }
            selectOpen={ selectOpen }
            handleSelectOpen={ handleSelectOpen }
            handleSelectClose={ handleSelectClose } />
    )
}

export default DashboardParent;